export default "__VITE_ASSET__2f0e4e57__"